'use client'

import React, { useState, useEffect } from "react"
import { useGlobalContext } from "../context/provider"
import { AxiosGetData } from "../context/axiosfunction"
import { Swiper, SwiperSlide } from "swiper/react"

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import Image from "next/image"
import { imageLoader } from "@/lib/functionloader"
import { Segmented } from "antd"
import CouponGuidePage from "./component/howto"
import SVGCoupon from "./component/SvgCoupon"
import MyCoupon from "./component/mycoupon"
import Link from "next/link"
import Hashids from "hashids"

const MainPro = () => {
    const [eventdata, setEvent] = useState([])
    const [coupon, setCoupon] = useState([])
    const { API, headers, privateKey } = useGlobalContext()
    const [options, setOption] = useState('โปรโมชั่น')
    const [couponuser, setCouponUser] = useState([])
    
    useEffect(() => {
        const getEvent = async() => {
            const response = await AxiosGetData(API, '/api/get_event_page', headers, privateKey)
            setEvent(response.event)
            setCoupon(response.coupon)
            setCouponUser(response.coupon_user)
        }
        getEvent()
    }, [API, headers, privateKey])

    return (
        <div className="max-w-[1280px] py-6 px-4 mx-auto font-sans">
            {/* Banner Slider Section */}
            <div className="rounded-2xl overflow-hidden shadow-md">
                <Swiper
                    slidesPerView={1}
                    spaceBetween={0}
                    modules={[Navigation, Pagination, Autoplay]}
                    className="w-full"
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    pagination={{ clickable: true }}
                >
                    {eventdata?.map((data) => {
                        // สร้าง encodedID สำหรับลิงก์ไปยังหน้าโปรโมชั่น
                        const hashids = new Hashids(privateKey, 6)
                        const encodedID = hashids.encode(data.campaign_id)

                        return (
                            <SwiperSlide key={data.campaign_id}>
                                {/* นำ Link มาครอบส่วนของ Banner เพื่อให้กดได้ */}
                                <Link href={`/promotion/${encodedID}`} className="block w-full h-full cursor-pointer group">
                                    {/* กำหนดความสูงตายตัวในแต่ละหน้าจอไปเลย เพื่อไม่ให้แบนเนอร์ใหญ่ทะลุจอ */}
                                    <div className="relative w-full h-[220px] sm:h-[300px] md:h-[380px] lg:h-[450px] flex items-center justify-center overflow-hidden">
                                        
                                        {/* เลเยอร์ที่ 1: ภาพพื้นหลังเบลอ */}
                                        <div className="absolute inset-0">
                                            <Image
                                                fill
                                                loader={imageLoader}
                                                src={data.campaign_img}
                                                alt="background blur"
                                                className="object-cover opacity-90 blur-2xl scale-110"
                                            />
                                        </div>
                                        
                                        {/* เลเยอร์ที่ 2: ภาพหลัก (รูปจะย่อตัวเองให้พอดีกับความสูงที่เราตั้งไว้โดยอัตโนมัติ) */}
                                        <div className="absolute inset-0 z-10 p-2 md:p-4"> 
                                            <Image
                                                fill
                                                loader={imageLoader}
                                                src={data.campaign_img}
                                                alt={data.name || 'cover'}
                                                className="object-contain drop-shadow-2xl group-hover:scale-[1.02] transition-transform duration-300"
                                            />
                                        </div>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
            {/* Menu Tabs Section */}
            <div className="my-8 max-w-2xl mx-auto">
                <Segmented 
                    onChange={(value) => setOption(value)} 
                    className="w-full p-1 font-bold text-base shadow-sm border border-gray-100 rounded-lg" 
                    block 
                    size="large" 
                    options={['โปรโมชั่น', 'คูปองของฉัน', 'วิธีใช้งาน']} 
                />
            </div>

            {/* Content Section */}
            <div className="mb-10">
                {options === 'โปรโมชั่น' && (
                    <div>
                        {eventdata.length > 0 ? (
                            <div className="animate-fade-in">
                                <div className="flex items-center mb-6">
                                    <h2 className="text-2xl font-bold text-primary  tracking-wide">
                                        🎉 โปรโมชั่นทั้งหมด
                                    </h2>
                                </div>
                                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                                    {eventdata?.map((data) => {
                                        const hashids = new Hashids(privateKey, 6)
                                        const encodedID = hashids.encode(data.campaign_id)

                                        return (
                                            <div
                                                key={data.campaign_id}
                                                className="group page-surface text-primary  rounded-2xl flex flex-col overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                                            >
                                                {/* Card Image */}
                                                <div className="relative aspect-[1200/720] overflow-hidden bg-gray-100">
                                                    <img
                                                        src={data.campaign_img}
                                                        alt={data.name}
                                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out"
                                                    />
                                                </div>
                                                
                                                {/* Card Body */}
                                                <div className="p-4 flex flex-col flex-1">
                                                    <h3 className="text-base md:text-lg font-bold line-clamp-2 mb-4 group-hover:text-pink-600 transition-colors">
                                                        {data.campaign_name}
                                                    </h3> 
                                                    
                                                    {/* Card Action */}
                                                    <div className="mt-auto pt-2">
                                                        <Link 
                                                            href={`/promotion/${encodedID}`} 
                                                            className="block w-full bg-pink-500 hover:bg-pink-600 active:scale-95 text-center text-white font-medium py-2 px-4 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md"
                                                        >
                                                            ดูรายละเอียด
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        ) : (
                            <div className="flex flex-col items-center justify-center py-20 text-gray-400 bg-gray-50/50 rounded-2xl border border-dashed border-gray-200">
                                <img
                                    src="https://serverimges.bookfet.com/static/empty_event.png"
                                    alt="no-event"
                                    className="w-48 h-48 mb-6 opacity-60 drop-shadow-sm"
                                />
                                <div className="text-xl font-medium text-gray-500">ยังไม่มีโปรโมชั่นในตอนนี้</div>
                                <p className="text-sm mt-2">โปรดติดตามกิจกรรมดีๆ เร็วๆ นี้</p>
                            </div>
                        )}

                        {coupon.length > 0 && (
                            <div className="mt-12 pt-8 border-t border-gray-100">
                                <h2 className="text-2xl font-bold text-gray-800 mb-6 tracking-wide">
                                    🎟️ คูปองทั้งหมด
                                </h2>
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                    {coupon.map((data, index) => (
                                        <div key={index} className="relative w-full rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300">
                                            <SVGCoupon data={data} coupon_user={couponuser} page="main" setuser_pone={setCouponUser} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
                
                {options === 'คูปองของฉัน' && <div className="animate-fade-in"><MyCoupon/></div>}
                
                {options === 'วิธีใช้งาน' && <div className="animate-fade-in"><CouponGuidePage /></div>}
            </div>
        </div>
    )
}

export default MainPro